module.exports = __webpack_public_path__ + "img/76.7c4a3164.jpg";